import React from 'react'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'

import Layout from '../components/layout/Layout'

function ManageSearch() {
  const navigate = useNavigate()

  return (
    <Layout>
      <h1>Manage Search</h1>
      <Button
        type="default"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          navigate(`/manageSearch/addStarterActivities`)
        }}
        loading={false}
      >
        Handle starter activities
      </Button>
    </Layout>
  )
}

export default ManageSearch
